import { HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { LoginService } from '../services';
import { catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';

export const authTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(LoginService);
  const authToken = authService.getToken();
  const router = inject(Router);

  if (authToken) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${authToken}`
      }
    });
  }
  return next(req).pipe(
    catchError(error => {
      if (error.status === 401) {
        authService.logout();
        router.navigate(['/account/login']);
      }
      return throwError(() => error);
    })
  );
}

// import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
// import { inject } from '@angular/core';
// import { AuthService } from '../services';
// import { ENDPOINTS } from '../constants';
// import { BehaviorSubject, catchError, filter, switchMap, take, throwError } from 'rxjs';

// let isRefreshing = false;
// const tokenSubject = new BehaviorSubject<string | null>(null);

// export const authTokenInterceptor: HttpInterceptorFn = (req, next) => {
//   const authService = inject(AuthService);
//   const authToken = authService.getToken();

//   const excludeURLs = [ENDPOINTS.AUTH.LOGIN, ENDPOINTS.AUTH.REFRESH_TOKEN];
//   if (excludeURLs.some(url => req.url.includes(url))) {
//     return next(req);
//   }

//   if (authToken) {
//     req = addAuthorizationHeader(req, authToken);
//   }

//   return next(req).pipe(
//     catchError(error => {
//       if (error.status === 401) {
//         return handle401Error(req, next, authService);
//       }
//       return throwError(() => error);
//     })
//   );
// };

// function handle401Error(req: HttpRequest<any>, next: HttpHandlerFn, authService: AuthService) {
//   if (!isRefreshing) {
//     isRefreshing = true;
//     tokenSubject.next(null);

//     return authService.refreshToken().pipe(
//       switchMap((response) => {
//         isRefreshing = false;
//         const newAccessToken = response?.result?.token;
//         if (newAccessToken) {
//           tokenSubject.next(newAccessToken);
//           req = addAuthorizationHeader(req, newAccessToken);
//           return next(req);
//         } else {
//           throw new Error('No new access token');
//         }
//       }),
//       catchError(error => {
//         isRefreshing = false;
//         authService.onSessionExpired();
//         return throwError(() => error);
//       })
//     );
//   } else {
//     return tokenSubject.pipe(
//       filter((token) => token != null),
//       take(1),
//       switchMap((token) => {
//         return next(addAuthorizationHeader(req, token!));
//       })
//     );
//   }

// }

// function addAuthorizationHeader(request: HttpRequest<any>, token: string) {
//   return request.clone({
//     setHeaders: {
//       Authorization: `Bearer ${token}`
//     }
//   });
// }
